<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item">
                <router-link to="/incomes">{{$t('income_list')}}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">{{ $t('income_create') }}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button>
            <b-btn variant="outline-primary no-bor" size="sm" @click="clickSaveHandler"><i class="fa fa-floppy-o" aria-hidden="true"></i> {{$t('save')}}</b-btn>
        </div>
        <div class="x_body">
            <div class="card f_card">
                <div class="card-body">
                    <div v-if="$v.$error" class="alert alert-danger x-error">
                        <div class="error" v-if="!$v.model.AccountId.required">- សូមធ្វើការបញ្ជូលប្រភេទចំណូល</div>
                        <div class="error" v-if="!$v.model.Amount.required || !$v.model.Amount.minValue">{{$t('error.minZero')}}</div>
                        <div class="error" v-if="!$v.model.Description.required">- សូមធ្វើការបញ្ជូលបរិយាយចំណូល</div>
                        <div class="error" v-if="!$v.date.required">- សូមធ្វើការបញ្ជូលកាលបរិច្ឆេទទទួលចំណូល</div>
                    </div>
                    <form ref="form">
                        <div class="row">
                            <div class="col-sm-3">
                                <div class="form-group">
                                    <label class="label-control">{{$t('invoice_no')}}</label>
                                    <div>
                                        <input type="text" class="form-control" v-model="model.InvoiceNum"/>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-3">
                                <div class="form-group" :class="{ 'form-group-error': $v.date.$error }">
                                    <label class="label-control">{{$t('date')}}</label>
                                    <div>
                                        <input type="date" class="form-control" v-model="$v.date.$model"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-3">
                                <div class="form-group" :class="{ 'form-group-error': $v.model.AccountId.$error }">
                                    <label class="label-control blue">{{$t('income_type')}}</label>
                                    <div>
                                        <select class="form-control" v-model="$v.model.AccountId.$model">
                                            <option value="">ជ្រើសរើសប្រភេទចំណូល</option>
                                            <option v-for="(ret,index) in incomes" :value="ret.Id" :key="index">{{ret.Name}}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-3">
                                <div class="form-group">
                                    <label class="label-control">{{$t('payment_method')}}</label>
                                    <div>
                                        <select class="form-control" v-model="model.MethodId">
                                            <option value="Cash">{{$t('cash')}}</option>
                                            <option value="Bank">{{$t('bank')}}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-3">
                                <div class="form-group">
                                    <label class="label-control">{{$t('balance')}}</label>
                                    <div>
                                        <input type="number" class="form-control" min="0" v-model="model.Balance"/>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-3">
                                <div class="form-group" :class="{ 'form-group-error': $v.model.Amount.$error }">
                                    <label class="label-control">{{$t('amount')}}</label>
                                    <div>
                                        <input type="number" class="form-control" min="0" v-model="$v.model.Amount.$model"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-6">
                                <b-form-group class="label-control blue" :label="$t('description')" :class="{ 'form-group-error': $v.model.Description.$error }">
                                    <b-form-textarea v-model="$v.model.Description.$model"/>
                                </b-form-group>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { required, minValue } from 'vuelidate/lib/validators'
    export default {
        data: function(){
            return {
                model:{
                    Date: '',
                    Description: '',
                    AccountId: '',
                    InvoiceNum: '',
                    Amount: 0,
                    Balance: 0
                },
                date: this.$now().format('YYYY-MM-DD'),
                incomes: [],
                actionLink: 'sale/receipt/save'
            }
        },
        validations:{
            model: {
                AccountId: { required },
                Description: { required },
                Amount: { required, minValue: minValue(1) }
            },
            date: { required }
        },
        created: function(){
            this.$api().post('accounting/accounts', { AccountTypeName: 'Income' }).then(res => {
                if(this.$isValid(res)){
                    this.incomes = res.data.Data;
                }
            });
          const id = this.$route.params.id;
          if(id !== undefined && id != null && id !== ''){
            this.actionLink = 'sale/receipt/update';
            this.findById(id);
          }
        },
        methods: {
            findById(id){
                var loading = this.$loading.show();
                this.$api().post('sale/receipt/find', { Id: id }).then(res => {
                    if(this.$isValid(res)){
                        this.model = res.data.Data;
                    }
                }).finally(function(){ loading.hide(); });
            },
            clickSaveHandler(){
                this.$v.$touch();
                if(!this.$v.$invalid){
                    var loading = this.$loading.show();
                    this.model.Date = this.date;
                    this.$api().post(this.actionLink, this.model).then(res => {
                        if(this.$isValid(res)){
                            this.$router.push('/incomes');
                        }
                    }).finally(function(){ loading.hide(); });
                }
            }
        },
    }
</script>
